import { render } from "./SettingsBotRive.vue?vue&type=template&id=35a42868&scoped=true"
import script from "./SettingsBotRive.vue?vue&type=script&lang=js"
export * from "./SettingsBotRive.vue?vue&type=script&lang=js"

import "./SettingsBotRive.vue?vue&type=style&index=0&id=35a42868&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a42868"]])

export default __exports__